import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  Renderer2,
  RendererStyleFlags2,
  SimpleChanges
} from '@angular/core';

@Directive({
  selector: '[kpiCardWrapDirective]',
  standalone: true
})
export class KpiCardWrapDirective implements AfterViewInit, OnDestroy, OnChanges {
  @Input() kpiCount!: number;
  @Input() kpiWidth!: number;

  private ro?: ResizeObserver;
  private el: ElementRef<HTMLElement> = inject<ElementRef<HTMLElement>>(ElementRef);
  private r: Renderer2 = inject(Renderer2);
  private kpisContainer?: HTMLElement;
  private currentKpiCard!: HTMLElement;

  ngAfterViewInit(): void {
    this.currentKpiCard = this.el.nativeElement;
    this.kpisContainer =
      this.currentKpiCard.parentElement?.parentElement?.parentElement ?? undefined;

    if (!this.kpisContainer) return;
    this.ro = new ResizeObserver(() => {
      this.update();
    });
    this.ro.observe(this.kpisContainer);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['kpiCount'] && this.kpisContainer) {
      this.update();
    }
  }

  ngOnDestroy(): void {
    this.ro?.disconnect();
  }

  private update(): void {
    if (!this.kpisContainer) return;
    const kpisContainerWidth = this.kpisContainer.clientWidth;
    const oneRowOfCardsWidth = this.kpiCount * this.kpiWidth;

    if (oneRowOfCardsWidth <= kpisContainerWidth) {
      // Setting number of columns to the number of cards, all fit in one row
      this.r.setStyle(this.currentKpiCard, '--cols', this.kpiCount, RendererStyleFlags2.DashCase);
      return;
    }

    const maxColsFit = Math.floor(kpisContainerWidth / this.kpiWidth);
    const cols = this.getColCount(this.kpiCount, maxColsFit);

    this.r.setStyle(this.currentKpiCard, '--cols', cols, RendererStyleFlags2.DashCase);
  }

  private getColCount(count: number, maxColsFit: number): number {
    let cols = maxColsFit;
    // This avoids having a single card in the last row.
    while (cols > 2 && count % cols === 1) {
      cols--;
    }

    return cols;
  }
}
